// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__15TR9","col":"styles_col__34DOZ"};